import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../../../api';

const CompleteAssetModal = () => {
  const [caseData, setCaseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [caseId, setCaseId] = useState(null);

  const fetchCaseDetails = async (id) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axiosInstance.get('/case-completed-listing');

      if (response.data?.data?.length > 0) {
        const match = response.data.data.find(item => String(item.id) === String(id));
        if (match) {
          setCaseData(match);
        } else {
          setError('Case not found');
        }
      } else {
        setError('No cases found');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const modal = document.getElementById('bs-show-Assets');
    const handleShow = (event) => {
      const button = event.relatedTarget;
      const id = button?.getAttribute('data-case-id');
      setCaseId(id);
      fetchCaseDetails(id);
    };

    modal?.addEventListener('show.bs.modal', handleShow);
    return () => modal?.removeEventListener('show.bs.modal', handleShow);
  }, []);

  return (
    <div className="modal fade" id="bs-show-Assets" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header d-flex align-items-center">
            <h4 className="modal-title">Assets</h4>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div className="modal-body">
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" />
              </div>
            ) : error ? (
              <div className="alert alert-danger">{error}</div>
            ) : (
              <form>
                <div className="row mb-5">
                  <div className="col-md-6 mb-md-0 mb-3">
                    <label>Case Name</label>
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={caseData?.case_name || ''}
                    />
                  </div>
                  <div className="col-md-6">
                    <label>Case Type</label>
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={caseData?.case_type || ''}
                    />
                  </div>
                </div>

                

                <div className="row mb-2 fw-bold">
                  <h6 className="col-3">Assets</h6>
                  <h6 className="col-6">Name</h6>
                  <h6 className="col-3">Qty</h6>
                </div>

                {caseData?.assets?.length > 0 ? (
                  caseData.assets.map((item, index) => (
                    <div className="row mb-3" key={index}>
                      <div className="col-3 d-flex align-items-center px-md-3 px-2">
                        <label>{`Asset - ${index + 1}`}</label>
                      </div>
                      <div className="col-6">
                        <input
                          type="text"
                          className="form-control px-md-3 px-2"
                          readOnly
                          value={item.asset.assets_name}
                        />
                      </div>
                      <div className="col-3">
                        <input
                          type="text"
                          className="form-control px-md-3 px-2"
                          readOnly
                          value={item.quantity}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No assets available for this case.</p>
                )}
              </form>
            )}
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn bg-danger-subtle text-danger"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompleteAssetModal;
